/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CampoMensa } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { ServizioCreationForm } from '../model/models';
import { ServizioDTO } from '../model/models';
import { ServizioDaTemplateForm } from '../model/models';
import { ServizioMensaAttributoMappingDTO } from '../model/models';
import { ServizioMensaAttributoMappingUpsertForm } from '../model/models';
import { ServizioMensaUpdateForm } from '../model/models';
import { ServizioUpdateForm } from '../model/models';
import { TariffaMensaDTO } from '../model/models';
import { TariffaMensaSimulaForm } from '../model/models';
import { TariffaMensaSimulazioneDTO } from '../model/models';
import { TariffaMensaUpsertForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaServizioRequestParams {
    idTipoPratica: string;
    servizioCreationForm: ServizioCreationForm;
}

export interface CreateTipoPraticaServizioDaTemplateRequestParams {
    idTipoPratica: string;
    servizioDaTemplateForm: ServizioDaTemplateForm;
}

export interface DeleteServizioMensaAttributoMappingRequestParams {
    idTipoPratica: string;
    idServizio: string;
    campoMensa: CampoMensa;
}

export interface DeleteTariffaMensaRequestParams {
    idTipoPratica: string;
    idServizio: string;
}

export interface DeleteTipoPraticaServizioRequestParams {
    idTipoPratica: string;
    idServizio: string;
}

export interface GetTariffaMensaRequestParams {
    idTipoPratica: string;
    idServizio: string;
}

export interface GetTipoPraticaServizioRequestParams {
    idTipoPratica: string;
    idServizio: string;
}

export interface ListServizioMensaAttributoMappingRequestParams {
    idTipoPratica: string;
    idServizio: string;
}

export interface ListTipoPraticaServiziRequestParams {
    idTipoPratica: string;
}

export interface SimulaTariffaMensaRequestParams {
    idTipoPratica: string;
    idServizio: string;
    tariffaMensaSimulaForm: TariffaMensaSimulaForm;
}

export interface UpdateTipoPraticaServizioCommonRequestParams {
    idTipoPratica: string;
    idServizio: string;
    servizioUpdateForm: ServizioUpdateForm;
}

export interface UpdateTipoPraticaServizioMensaRequestParams {
    idTipoPratica: string;
    idServizio: string;
    servizioMensaUpdateForm: ServizioMensaUpdateForm;
}

export interface UpsertServizioMensaAttributoMappingRequestParams {
    idTipoPratica: string;
    idServizio: string;
    servizioMensaAttributoMappingUpsertForm: ServizioMensaAttributoMappingUpsertForm;
}

export interface UpsertTariffaMensaRequestParams {
    idTipoPratica: string;
    idServizio: string;
    tariffaMensaUpsertForm: TariffaMensaUpsertForm;
}


export interface ServiziSUPERADMINServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un Servizio per il TipoPratica (con payload sottotipo annidato)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi
* @param requestParameters
     */
    createTipoPraticaServizio(requestParameters: CreateTipoPraticaServizioRequestParams, extraHttpRequestParams?: any): Observable<ServizioDTO>;

    /**
     * Crea un ServizioMensa da template predefinito, tariffa pre-popolata (SUPERADMIN)
     * Bootstrap del satellite ServizioMensa + TariffaMensa pre-popolata a partire da un template server-side (&#x60;MENSA_ESEMPIO&#x60;). 201 + ServizioDTO; 404 bando inesistente; 400 tipologia non-MENSA; 409 servizio MENSA gia\&#39; presente; 422 dataFine &lt; dataInizio.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/da-template
* @param requestParameters
     */
    createTipoPraticaServizioDaTemplate(requestParameters: CreateTipoPraticaServizioDaTemplateRequestParams, extraHttpRequestParams?: any): Observable<ServizioDTO>;

    /**
     * Elimina il mapping di un concetto mensa
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}/attributo-mappings/{campoMensa}
* @param requestParameters
     */
    deleteServizioMensaAttributoMapping(requestParameters: DeleteServizioMensaAttributoMappingRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Elimina la configurazione tariffaria; azzera i contributi degli studenti materializzati
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}/tariffa-mensa
* @param requestParameters
     */
    deleteTariffaMensa(requestParameters: DeleteTariffaMensaRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Elimina un Servizio (cascade JOINED sui sottotipi)
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}
* @param requestParameters
     */
    deleteTipoPraticaServizio(requestParameters: DeleteTipoPraticaServizioRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Legge la configurazione tariffaria del servizio mensa
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}/tariffa-mensa
* @param requestParameters
     */
    getTariffaMensa(requestParameters: GetTariffaMensaRequestParams, extraHttpRequestParams?: any): Observable<TariffaMensaDTO>;

    /**
     * Dettaglio di un Servizio per id (include sottotipo)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}
* @param requestParameters
     */
    getTipoPraticaServizio(requestParameters: GetTipoPraticaServizioRequestParams, extraHttpRequestParams?: any): Observable<ServizioDTO>;

    /**
     * Lista dei mapping concetto mensa → attributo del ServizioMensa
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}/attributo-mappings
* @param requestParameters
     */
    listServizioMensaAttributoMapping(requestParameters: ListServizioMensaAttributoMappingRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaAttributoMappingDTO>>;

    /**
     * Lista dei Servizi del TipoPratica (include sottotipo)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi
* @param requestParameters
     */
    listTipoPraticaServizi(requestParameters: ListTipoPraticaServiziRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioDTO>>;

    /**
     * Simula (dry-run) il contributo di una bozza di tariffa su un profilo-studente d\&#39;esempio; nessun side-effect
     * Applica lo stesso motore di produzione alla tariffa inviata nel body (NON letta dal DB) e ritorna contributo, costo pasto, regola vincente e avvisi non bloccanti. Sempre 200: una bozza malformata produce warnings, non un errore.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}/tariffa-mensa/simula
* @param requestParameters
     */
    simulaTariffaMensa(requestParameters: SimulaTariffaMensaRequestParams, extraHttpRequestParams?: any): Observable<TariffaMensaSimulazioneDTO>;

    /**
     * Replace della parte comune di un Servizio (richiede version per optimistic lock)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}
* @param requestParameters
     */
    updateTipoPraticaServizioCommon(requestParameters: UpdateTipoPraticaServizioCommonRequestParams, extraHttpRequestParams?: any): Observable<ServizioDTO>;

    /**
     * Replace della parte mensa-specifica di un Servizio (richiede version applicativa per optimistic lock)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}/mensa
* @param requestParameters
     */
    updateTipoPraticaServizioMensa(requestParameters: UpdateTipoPraticaServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<ServizioDTO>;

    /**
     * Upsert di un mapping (create se version assente, update con optimistic lock)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}/attributo-mappings
* @param requestParameters
     */
    upsertServizioMensaAttributoMapping(requestParameters: UpsertServizioMensaAttributoMappingRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaAttributoMappingDTO>;

    /**
     * Upsert (PUT-replace) della configurazione tariffaria; ricalcola i contributi degli studenti materializzati
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/servizi/{idServizio}/tariffa-mensa
* @param requestParameters
     */
    upsertTariffaMensa(requestParameters: UpsertTariffaMensaRequestParams, extraHttpRequestParams?: any): Observable<TariffaMensaDTO>;

}
